import { useQuery } from "@tanstack/react-query";
import {
  CustomValuesImportsParams,
  CustomValuesImportsResponse,
  fetchCustomValuesImports
} from "PFCore/services/admin/imports/fetch_custom_values_imports";
import { Id } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { customValuesImportsKeys } from "./query_keys";

export const useCustomValuesImports = (
  customTypeId: Id,
  params?: CustomValuesImportsParams,
  options?: QueryOptions<CustomValuesImportsResponse>
) =>
  useQuery<CustomValuesImportsResponse>(
    customValuesImportsKeys.ofType(customTypeId, params),
    () => fetchCustomValuesImports(customTypeId, params),
    { staleTime: 0, ...options }
  );
